import React, { FC, useContext } from 'react'

import { useWizardStep } from 'react-wizard-primitive'

import { AppContext } from 'Const'

import CustomerFieldsGroup from 'Components/CustomerFieldsGroup'

import { StepContext } from '..'
import NextStepBtn from '../NextStepBtn'

const CustomerStep: FC = () => {
  const { customer } = useContext(AppContext)
  const { checkouting, nextStep } = useContext(StepContext)
  const { isActive, resetToStep } = useWizardStep()

  return (
    <CustomerFieldsGroup
      customer={customer}
      isActive={isActive}
      renderSubmitButton={(submit, loading) => <NextStepBtn loading={loading} onSubmit={submit} />}
      submitting={checkouting}
      onChangeStep={resetToStep}
      onComplete={(customer) => nextStep({ customer })}
    />
  )
}

export default CustomerStep
